import { z } from 'zod';
import { FilterDataSchema, FilterTypeEnum } from '../types/filter.js';

// Re-export core types from types folder
export type { FilterItemValue, FilterItem, FilterData } from '../types/filter.js';
export { FilterItemSchema, FilterDataSchema, parseFilterData } from '../types/filter.js';

// Complete filter schema used by API responses
export const FilterSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  label: z.string(),
  type: z.enum(FilterTypeEnum),
  operators: z.array(z.string()),
  data: FilterDataSchema,
});

export type FilterZod = z.infer<typeof FilterSchema>;

// API request schemas for app-v1 endpoints
export const CreateFilterSchema = z.object({
  identifier: z.string(),
  label: z.string(),
  type: z.enum(FilterTypeEnum),
  operators: z.array(z.string()),
  data: FilterDataSchema,
});

export const UpdateFilterSchema = z.object({
  identifier: z.string().optional(),
  label: z.string().optional(),
  type: z.enum(FilterTypeEnum).optional(),
  operators: z.array(z.string()).optional(),
  data: FilterDataSchema.optional(),
});

export type CreateFilterInput = z.infer<typeof CreateFilterSchema>;
export type UpdateFilterInput = z.infer<typeof UpdateFilterSchema>;

// API response schemas for app-v1 endpoints
export const FetchFiltersResponseModel = z.object({
  filters: z.array(FilterSchema),
});

export const FetchFilterResponseModel = z.object({
  filter: FilterSchema,
});

export namespace CreateFilter {
  export const RequestSchema = CreateFilterSchema;
  export type Request = z.infer<typeof RequestSchema>;
}

export const CreateFilterResponseModel = z.object({
  filter: FilterSchema,
});

export namespace UpdateFilter {
  export const RequestSchema = UpdateFilterSchema.extend({
    id: z.number(),
  });
  export type Request = z.infer<typeof RequestSchema>;
}

export const UpdateFilterResponseModel = z.object({
  filter: FilterSchema,
});

export const FetchFilterRequestModel = z.object({
  filterId: z.number(),
});

// Parameter schema for parsing route params
export const FilterParamsSchema = z.object({
  id: z.string().transform((val) => {
    const parsed = parseInt(val, 10);
    if (isNaN(parsed)) {
      throw new Error('Invalid filter ID');
    }
    return parsed;
  }),
});

export type FilterParams = z.infer<typeof FilterParamsSchema>;
